<script>
  import { page } from '@inertiajs/svelte'
  import { onMount } from 'svelte'
  import { loadGoogleMaps } from './google_maps_loader.js'

  // Click-to-place a marker. `lat`/`lng` are bindable; `onchange` also fires with { lat, lng }
  // for callers that just want a callback (place_search.svelte drives lat/lng the same way).
  let {
    lat = $bindable(null),
    lng = $bindable(null),
    editable = true,
    height = 320,
    onchange
  } = $props()

  const apiKey = $derived($page.props.google_maps_api_key)

  let mapEl = $state()
  let map
  let marker
  let failed = $state(false)

  const DEFAULT_CENTER = { lat: 40.7128, lng: -74.006 }

  const placeMarker = (position) => {
    if (!marker) {
      marker = new google.maps.Marker({ map, position, draggable: editable })
      if (editable) {
        marker.addListener('dragend', () => {
          const newPosition = marker.getPosition()
          lat = newPosition.lat()
          lng = newPosition.lng()
          onchange?.({ lat, lng })
        })
      }
    } else {
      marker.setPosition(position)
    }
  }

  onMount(() => {
    if (!apiKey) {
      failed = true
      return
    }

    loadGoogleMaps(apiKey)
      .then(() => {
        const center = lat && lng ? { lat, lng } : DEFAULT_CENTER
        map = new google.maps.Map(mapEl, { center, zoom: lat && lng ? 15 : 11 })

        if (lat && lng) placeMarker({ lat, lng })

        if (editable) {
          map.addListener('click', (event) => {
            const position = { lat: event.latLng.lat(), lng: event.latLng.lng() }
            lat = position.lat
            lng = position.lng
            placeMarker(position)
            onchange?.(position)
          })
        }
      })
      .catch(() => (failed = true))
  })

  $effect(() => {
    if (map && lat && lng) placeMarker({ lat, lng })
  })
</script>

{#if failed}
  <div
    class="bg-base-200 border border-dashed border-base-300 rounded-box flex items-center justify-center text-base-content/60 text-sm"
    style="height: {height}px"
  >
    Map unavailable — GOOGLE_MAPS_API_KEY not configured.
  </div>
{:else}
  <div bind:this={mapEl} style="height: {height}px" class="rounded-box"></div>
{/if}
